import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatINR(val: number | string = 0, fixedDecimals = false): string {
  const num = Number(val) || 0;
  const hasDecimals = num % 1 !== 0 || fixedDecimals;
  return `₹${num.toLocaleString("en-IN", {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  })}`;
}


/** "HOME_FURNISHING" -> "Home Furnishing", for showing a stored lookup code; blank stays blank */
export function humanizeCode(code?: string | null): string | undefined {
  if (!code) return undefined;
  return code
    .toLowerCase()
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
